import { gql } from "@apollo/client";
export const ADD_ORDER_DELIVERY = gql`
    mutation AddOrderDelivery($where: OrderDeliveryWhereInput!, $data: OrderDeliveryInput!) {
        addOrderDelivery(where: $where, data: $data) {
            message
        }
    }
`;

// Joint Order Group
// export const JOINT_ORDER_GROUP = gql`
//     mutation JointOrderGroup($where: JointOrderGroupRequest!) {
//         jointOrderGroup(where: $where) {
//             message
//             data {
//                 id
//                 amount
//                 phone
//             }
//         }
//     }
// `;